import { useEffect, useState } from "react";
import styles from "./index.module.scss";
import Button from "components/Button/Button";
import Modal from "components/Modal/Modal";
import Card from "components/Card/Card";

const InstallPWAButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [showAndroidModal, setShowAndroidModal] = useState(false);

  useEffect(() => {
    localStorage.removeItem("pwa-installed");
    localStorage.removeItem("pwa-install-prompted");
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipod|ipad/.test(userAgent);
    };
    const isAndroid = () => /android/.test(navigator.userAgent.toLowerCase());
    const isInStandaloneMode = () =>
      "standalone" in window.navigator && (window.navigator as any).standalone;

    const handler = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowAndroidModal(true);
    };
    if (isIos() && !isInStandaloneMode()) {
      setShowModal(true);
      return;
    }
    if (isAndroid()) {
      window.addEventListener("beforeinstallprompt", handler);
    }
    return () => {
      if (isAndroid()) {
        window.removeEventListener("beforeinstallprompt", handler);
      }
    };
  }, []);

  const handleInstallClick = () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === "accepted") {
        console.log("PWA installed");
        localStorage.setItem("pwa-installed", "true");
      } else {
        console.log("PWA dismissed");
      }

      localStorage.setItem("pwa-install-prompted", "true");
      setShowAndroidModal(false);
    });
  };

  if (showModal)
    return (
      <Modal onClose={() => setShowModal(false)}>
        <div className={styles.pwaBox}>
          <Card className={styles.mobileCard}>
            <p style={{ fontSize: "16px", marginBottom: "20px" }}>
              📲 Install this app: <br></br> Tap <strong>Share</strong> and then{" "}
              <strong>“Add to Home Screen”</strong>
            </p>
            <Button
              onClick={() => setShowModal(false)}
              text="Got It"
              color="primary"
            />
          </Card>
        </div>
      </Modal>
    );

  return (
    <>
      {showAndroidModal && (
        <Modal onClose={() => setShowAndroidModal(false)}>
          <div className={styles.pwaBox}>
            <Card className={styles.pwa}>
              <p style={{ marginBottom: "20px" }}>
                Click to install PAWA360 app on your device
              </p>
              <Button
                onClick={handleInstallClick}
                text="Install App"
                color="primary"
              />
            </Card>
          </div>
        </Modal>
      )}
    </>
  );
};

export default InstallPWAButton;
